const LABEL_CONSTANTS = {
  dismissLabel: "Dismiss"
};
export {
  LABEL_CONSTANTS
};
//# sourceMappingURL=labels.constants.js.map
